// import "primeicons/primeicons.css";
// import "primereact/resources/themes/lara-light-indigo/theme.css";
// import "primereact/resources/primereact.css";
// import "primeflex/primeflex.css";
// import './app.css';
// import { Route, Routes, useNavigate } from "react-router-dom";
// import Login from "./Components/Layout/Login";
// import Main from "./Components/Layout/Main";
// import { useEffect } from "react";

// function App() {

//   const hasSessionId = !!sessionStorage.getItem('RoleName');
//   const navigate = useNavigate();

//   useEffect(() => {
//     if (!hasSessionId) {
//       navigate('/');
//     }
//   }, [hasSessionId, navigate]);

//   return (
//     <div >
//     <Routes>
//         <Route path="/" element={<Login />} />
//         <Route path="/main/*" element={<Main />} />
//       </Routes>
//     </div>
//   );
// }

// export default App;


import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import './app.css';
import { Route, Routes, useNavigate } from "react-router-dom";
import Login from "./Components/Layout/Login";
import Main from "./Components/Layout/Main";
import { useEffect, useState } from "react";

function App() {
  const hasSessionId = !!sessionStorage.getItem('RoleName');
  const navigate = useNavigate();
  const [isScreenTooSmall, setIsScreenTooSmall] = useState(false);

  useEffect(() => {
    const checkScreenWidth = () => {
      setIsScreenTooSmall(window.innerWidth <= 768); // Tablet screen width threshold
    };

    checkScreenWidth(); // Initial check
    window.addEventListener('resize', checkScreenWidth); // Add resize listener

    return () => {
      window.removeEventListener('resize', checkScreenWidth); // Cleanup listener
    };
  }, []);

  useEffect(() => {
    if (!hasSessionId) {
      navigate('/');
    }
  }, [hasSessionId, navigate]);

  if (isScreenTooSmall) {
    return (
      <div className="screen-warning">
        <h1>⚠️ Please access this page on your desktop!</h1>
      </div>
    );
  }

  return (
    <div>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/main/*" element={<Main />} />
      </Routes>
    </div>
  );
}

export default App;
